module.exports = __webpack_public_path__ + "img/hr-concrete-u.d1c48ca6.png";